import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import React, { useEffect } from "react";
import CustomeButton from "../Button";

const EditDocumentDescriptionModal = ({
  shoeDialog,
  data,
  setShowDialog,
  description,
  setDescription,
  handleUpdateDescription,
  loading,
  setResetDescription,
  resetDescription,
  safeDecode,
}) => {
  useEffect(() => {
    if (data) {
      setDescription(data?.description ? data?.description : "");
      setResetDescription(data?.description ? data?.description : "");
    }
  }, [data]);
  const decodedValue = safeDecode(description);

  return (
    <Dialog
      visible={shoeDialog}
      onHide={() => {}}
      className="confirmation-content"
    >
      <div className="edit__document__header">
        <span className="">
          {data?.description ? "Edit" : "Add"} Description for "{data?.name}"
        </span>
      </div>
      <InputTextarea
        value={safeDecode(description)}
        onChange={(e) => {
          setDescription(e.target.value);
        }}
        className={`input-field appearance-none outline-none w-full `}
        rows={18}
        maxLength={200}
        placeholder="Add your message here..."
      />
      <p className="text__limit">{decodedValue?.length || 0}/200</p>
      <div className="flex justify-content-end">
        <CustomeButton
          label="Cancel"
          onClick={() => {
            setShowDialog(false);
            setDescription(resetDescription);
          }}
        />
        <CustomeButton
          label="Save"
          variant="contained"
          loading={loading}
          disabled={!description?.length}
          iconPos="right"
          onClick={() => {
            handleUpdateDescription(data?.name, description);
          }}
        />
      </div>
    </Dialog>
  );
};

export default EditDocumentDescriptionModal;
